"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAllClaimableAmounts = void 0;
const quarry_sdk_1 = require("@quarryprotocol/quarry-sdk");
const token_utils_1 = require("@saberhq/token-utils");
const bn_js_1 = __importDefault(require("bn.js"));
const lodash_zip_1 = __importDefault(require("lodash.zip"));
const react_1 = require("react");
const useGetAllClaimableAmounts = ({ token, quarriesData, minersData, }) => {
    const payrolls = (0, react_1.useMemo)(() => {
        return (0, lodash_zip_1.default)(quarriesData, minersData).map(([quarry, miner]) => {
            const quarryData = quarry === null || quarry === void 0 ? void 0 : quarry.accountInfo.data;
            const minerData = miner === null || miner === void 0 ? void 0 : miner.accountInfo.data;
            const payroll = quarryData
                ? new quarry_sdk_1.Payroll(quarryData.famineTs, quarryData.lastUpdateTs, quarryData.annualRewardsRate, quarryData.rewardsPerTokenStored, quarryData.totalTokensDeposited)
                : null;
            return { payroll, minerData };
        });
    }, [minersData, quarriesData]);
    const getAllClaimableAmounts = (0, react_1.useCallback)((additionalMilliseconds = 0) => {
        if (!token) {
            return null;
        }
        const now = new bn_js_1.default(Math.floor((new Date().getTime() + additionalMilliseconds) / 1000));
        const allClaimable = payrolls.map(({ payroll, minerData }) => {
            if (!payroll || !minerData) {
                return null;
            }
            const rewards = payroll.calculateRewardsEarned(now, minerData.balance, minerData.rewardsPerTokenPaid, minerData.rewardsEarned);
            try {
                return new token_utils_1.TokenAmount(token, rewards);
            }
            catch (e) {
                console.error(`Could not parse claimable amount`, e);
                return null;
            }
        });
        const allAmounts = allClaimable.filter((t) => !!t);
        const sum = allAmounts.length > 0
            ? allAmounts.reduce((acc, el) => acc.add(el))
            : null;
        return {
            sum,
            allClaimable,
        };
    }, [payrolls, token]);
    return {
        payrolls: payrolls.map((p) => p.payroll),
        getAllClaimableAmounts,
    };
};
exports.useGetAllClaimableAmounts = useGetAllClaimableAmounts;
//# sourceMappingURL=useGetAllClaimableAmounts.js.map